//Archivo dedicado al menu de todos los imports Sistema de Verificación de Asistencia y Caja

//-----------Principal-----------
import Plantilla from '@/components/SIVAC/Comun/Plantilla.vue';

//-----------Administración-----------
import AltaCaja from '@/components/SIVAC/Administracion/AltaCaja.vue';
import AltaFirmas from '@/components/SIVAC/Administracion/AltaFirmas.vue';
import FirmasAdministracion from '@/components/SIVAC/Administracion/FirmasAdministracion.vue';
import ProcesadosAdministracion from '@/components/SIVAC/Administracion/ProcesadosAdministracion.vue';
import ProcesadosAdministracionExpedientes from '@/components/SIVAC/Administracion/ProcesadosAdministracionExpedientes.vue';
import ProcesadosReactivacion from '@/components/SIVAC/Administracion/ProcesadosReactivacion.vue';

//-----------Caja-----------
import Pagos from '@/components/SIVAC/Caja/Pagos.vue';
import CancelacionPagos from '@/components/SIVAC/Caja/Pagos.vue';
import DevolucionPagos from '@/components/SIVAC/Caja/Pagos.vue';

//-----------Firmas-----------
import Firmas from '@/components/SIVAC/Firmas/Firmas.vue';

//-----------Reportes-------------
import ReporteCaja from '@/components/SIVAC/Reportes/ReporteCaja.vue';
import ReporteFirmasNoVigentes from '@/components/SIVAC/Reportes/ReporteFirmasNoVigentes.vue';
import ReporteFirmasVigentes from '@/components/SIVAC/Reportes/ReporteFirmasVigentes.vue';
import ReporteDeMensajesRecibidos from '@/components/SIVAC/Reportes/ReporteDeMensajesRecibidos.vue';
import ReporteDeMensajesNoRecibidos from '@/components/SIVAC/Reportes/ReporteDeMensajesNoRecibidos.vue';
import ReporteDeCatalogoDeFirmantes from '@/components/SIVAC/Reportes/ReporteDeCatalogoDeFirmantes.vue';
import ReporteDeCatalogoDeFirmantesDadosDeBaja from '@/components/SIVAC/Reportes/ReporteDeCatalogoDeFirmantesDadosDeBaja.vue';
import ReporteDeBitacoraDeMovimientosRealizados from '@/components/SIVAC/Reportes/ReporteDeBitacoraDeMovimientosRealizados.vue';
import ReporteDeRelacionDeCertificadosCobrados from '@/components/SIVAC/Reportes/ReporteDeRelacionDeCertificadosCobrados.vue';
import ReporteDeRelacionDeCertificadosPagados from '@/components/SIVAC/Reportes/ReporteDeRelacionDeCertificadosPagados.vue';
import ReporteDeRelacionDeChequesCobrados from '@/components/SIVAC/Reportes/ReporteDeRelacionDeChequesCobrados.vue';




//-----------Mensajes-----------


import FirmasMensajes from '@/components/SIVAC/Mensajes/FirmasMensajes.vue';


//-----------Consultas-----------


import ConsultaDeCatalogoDeFirmantes from '@/components/SIVAC/Consultas/ConsultaDeCatalogoDeFirmantes.vue';
import ConsultaDeCatalogoDeFirmantesDadosDeBaja from '@/components/SIVAC/Consultas/ConsultaDeCatalogoDeFirmantesDadosDeBaja.vue';


//----------Verificación---------


import VerificacionReciboDeFirmas from '@/components/SIVAC/Verificacion/VerificacionReciboDeFirmas.vue';
import VerificacionReciboDePagos from '@/components/SIVAC/Verificacion/VerificacionReciboDePagos.vue';







//Se crea la lista de paths
const SIVAC = [
    {
      name: 'SIVAC', 
      path: '/SIVAC/', 
      component: Plantilla, 
      meta: { 
        tituloDeLaPagina: "Sistema de Verificación de Asistencia y Caja", 
        RequiereAutenticacion: true, 
        ValidaSesion: true, 
        ObtenDatos: true, 
        ObtenPermisosDelSistema: true, 
        SistemaQueSeIngreso:  38
        }, 
        children: [
        {
          name: 'Firmas', 
          path: 'Firmas', 
          component: Firmas,
          meta: { 
              tituloDeLaPagina: "Firma del procesado", 
              RequiereAutenticacion: true, 
              ValidaSesion: true, 
              ObtenDatos: true, 
              ObtenPermisosDelSistema: true, 
              SistemaQueSeIngreso: 38, 
              ModuloId: 1,
              FuncionId: 1
          }
        },
        {
          name: 'AltaCaja', 
          path: 'AltaCaja', 
          component: AltaCaja,
          meta: { 
              tituloDeLaPagina: "Alta en caja", 
              RequiereAutenticacion: true, 
              ValidaSesion: true, 
              ObtenDatos: true, 
              ObtenPermisosDelSistema: true, 
              SistemaQueSeIngreso: 38, 
              ModuloId: 2,
              FuncionId: 2
          } 
        },
        {

          name: 'Pagos', 
          path: 'Pagos', 
          component: Pagos, 
          meta: { 
              tituloDeLaPagina: "Pago en caja", 
              RequiereAutenticacion: true, 
              ValidaSesion: true, 
              ObtenDatos: true, 
              ObtenPermisosDelSistema: true, 
              SistemaQueSeIngreso: 38, 
              ModuloId: 2,
              FuncionId: 3
            }             
        },
        {
          name: 'CancelacionPagos', 
          path: 'CancelacionPagos', 
          component: CancelacionPagos,
          meta: { 
              tituloDeLaPagina: "Cancelación de pagos", 
              RequiereAutenticacion: true, 
              ValidaSesion: true, 
              ObtenDatos: true, 
              ObtenPermisosDelSistema: true, 
              SistemaQueSeIngreso: 38, 
              ModuloId: 2,
              FuncionId: 4
          }
        },
        {
          name: 'AltaFirmas', 
          path: 'AltaFirmas', 
          component: AltaFirmas,
          meta: { 
              tituloDeLaPagina: "Alta en firmas", 
              RequiereAutenticacion: true, 
              ValidaSesion: true, 
              ObtenDatos: true, 
              ObtenPermisosDelSistema: true, 
              SistemaQueSeIngreso: 38, 
              ModuloId: 3,
              FuncionId: 5
          } 
        },
        {
          name: 'FirmasAdministracion', 
          path: 'FirmasAdministracion', 
          component: FirmasAdministracion,
          meta: { 
              tituloDeLaPagina: "Administración de las firmas", 
              RequiereAutenticacion: true, 
              ValidaSesion: true, 
              ObtenDatos: true, 
              ObtenPermisosDelSistema: true, 
              SistemaQueSeIngreso: 38, 
              ModuloId: 3,
              FuncionId: 6
          }
        },
        {
          name: 'ProcesadosAdministracion', 
          path: 'ProcesadosAdministracion', 
          component: ProcesadosAdministracion,
          meta: { 
              tituloDeLaPagina: "Administración de los procesados", 
              RequiereAutenticacion: true, 
              ValidaSesion: true, 
              ObtenDatos: true, 
              ObtenPermisosDelSistema: true, 
              SistemaQueSeIngreso: 38, 
              ModuloId: 3,
              FuncionId: 7
          }
        },
        {
          name: 'ProcesadosAdministracionExpedientes', 
          path: 'ProcesadosAdministracionExpedientes', 
          component: ProcesadosAdministracionExpedientes,
          meta: { 
              tituloDeLaPagina: "Administración del expediente del procesado", 
              RequiereAutenticacion: true, 
              ValidaSesion: true, 
              ObtenDatos: true, 
              ObtenPermisosDelSistema: true, 
              SistemaQueSeIngreso: 38, 
              ModuloId: 3,
              FuncionId: 8
          }
        },
        {
           name: 'ReportesCaja', 
           path: 'ReportesCaja', 
           component: ReporteCaja,
           meta: { 
               tituloDeLaPagina: "Reportes de caja", 
               RequiereAutenticacion: true, 
               ValidaSesion: true, 
               ObtenDatos: true, 
               ObtenPermisosDelSistema: true, 
               SistemaQueSeIngreso: 38, 
               ModuloId: 4,
               FuncionId: 9
           } 
         },
         {
          name: 'ReporteFirmasNoVigentes', 
          path: 'ReporteFirmasNoVigentes', 
          component: ReporteFirmasNoVigentes,
          meta: { 
              tituloDeLaPagina: "Reporte de firmas no vigentes", 
              RequiereAutenticacion: true, 
              ValidaSesion: true, 
              ObtenDatos: true, 
              ObtenPermisosDelSistema: true, 
              SistemaQueSeIngreso: 38, 
              ModuloId: 4,
              FuncionId: 10
          }
        },
        {
          name: 'ReporteFirmasVigentes', 
          path: 'ReporteFirmasVigentes', 
          component: ReporteFirmasVigentes,
          meta: { 
              tituloDeLaPagina: "Reporte de firmas vigentes", 
              RequiereAutenticacion: true, 
              ValidaSesion: true, 
              ObtenDatos: true, 
              ObtenPermisosDelSistema: true, 
              SistemaQueSeIngreso: 38, 
              ModuloId: 4,
              FuncionId: 11
          }
        },
        {
          name: 'ReporteDeMensajesRecibidos', 
          path: 'ReporteDeMensajesRecibidos', 
          component: ReporteDeMensajesRecibidos,
          meta: { 
              tituloDeLaPagina: "Reporte de mensajes recibidos", 
              RequiereAutenticacion: true, 
              ValidaSesion: true, 
              ObtenDatos: true, 
              ObtenPermisosDelSistema: true, 
              SistemaQueSeIngreso: 38, 
              ModuloId: 4,
              FuncionId: 12
          }
        },
        {
          name: 'ReporteDeMensajesNoRecibidos', 
          path: 'ReporteDeMensajesNoRecibidos', 
          component: ReporteDeMensajesNoRecibidos,
          meta: { 
              tituloDeLaPagina: "Reporte de mensajes no recibidos", 
              RequiereAutenticacion: true, 
              ValidaSesion: true, 
              ObtenDatos: true, 
              ObtenPermisosDelSistema: true, 
              SistemaQueSeIngreso: 38, 
              ModuloId: 4,
              FuncionId: 13
          }
        },
        {
          name: 'ReporteDeCatalogoDeFirmantes', 
          path: 'ReporteDeCatalogoDeFirmantes', 
          component: ReporteDeCatalogoDeFirmantes,
          meta: { 
              tituloDeLaPagina: "Reporte de catalogo de firmantes", 
              RequiereAutenticacion: true, 
              ValidaSesion: true, 
              ObtenDatos: true, 
              ObtenPermisosDelSistema: true, 
              SistemaQueSeIngreso: 38, 
              ModuloId: 4,
              FuncionId: 14
          }
        },
        {
          name: 'ReporteDeCatalogoDeFirmantesDadosDeBaja', 
          path: 'ReporteDeCatalogoDeFirmantesDadosDeBaja', 
          component: ReporteDeCatalogoDeFirmantesDadosDeBaja,
          meta: { 
              tituloDeLaPagina: "Reporte de catalogo de firmantes dados de baja", 
              RequiereAutenticacion: true, 
              ValidaSesion: true, 
              ObtenDatos: true, 
              ObtenPermisosDelSistema: true, 
              SistemaQueSeIngreso: 38, 
              ModuloId: 4,
              FuncionId: 15
          }
        },
        {
          name: 'ReporteDeBitacoraDeMovimientosRealizados', 
          path: 'ReporteDeBitacoraDeMovimientosRealizados', 
          component: ReporteDeBitacoraDeMovimientosRealizados,
          meta: { 
              tituloDeLaPagina: "Reporte de bitacora de movimientos", 
              RequiereAutenticacion: true, 
              ValidaSesion: true, 
              ObtenDatos: true, 
              ObtenPermisosDelSistema: true, 
              SistemaQueSeIngreso: 38, 
              ModuloId: 4,
              FuncionId: 16
          }
        },
        {
          name: 'FirmasMensajes', 
          path: 'FirmasMensajes', 
          component: FirmasMensajes,
          meta: { 
              tituloDeLaPagina: "Mensaje para el procesado", 
              RequiereAutenticacion: true, 
              ValidaSesion: true, 
              ObtenDatos: true, 
              ObtenPermisosDelSistema: true, 
              SistemaQueSeIngreso: 38, 
              ModuloId: 5,
              FuncionId: 17
          }
        },
        {
          name: 'ConsultaDeCatalogoDeFirmantes', 
          path: 'ConsultaDeCatalogoDeFirmantes', 
          component: ConsultaDeCatalogoDeFirmantes,
          meta: { 
              tituloDeLaPagina: "Consulta del catalogo de firmantes", 
              RequiereAutenticacion: true, 
              ValidaSesion: true, 
              ObtenDatos: true, 
              ObtenPermisosDelSistema: true, 
              SistemaQueSeIngreso: 38, 
              ModuloId: 6,
              FuncionId: 18
          }
        },
        {
          name: 'ConsultaDeCatalogoDeFirmantesDadosDeBaja', 
          path: 'ConsultaDeCatalogoDeFirmantesDadosDeBaja', 
          component: ConsultaDeCatalogoDeFirmantesDadosDeBaja,
          meta: { 
              tituloDeLaPagina: "Consulta del catalogo de firmantes dados de baja", 
              RequiereAutenticacion: true, 
              ValidaSesion: true, 
              ObtenDatos: true, 
              ObtenPermisosDelSistema: true, 
              SistemaQueSeIngreso: 38, 
              ModuloId: 6,
              FuncionId: 19
          }
        },
        {
          name: 'VerificacionReciboDeFirmas', 
          path: 'VerificacionReciboDeFirmas', 
          component: VerificacionReciboDeFirmas,
          meta: { 
              tituloDeLaPagina: "Verificación de recibo de firmas", 
              RequiereAutenticacion: true, 
              ValidaSesion: true, 
              ObtenDatos: true, 
              ObtenPermisosDelSistema: true, 
              SistemaQueSeIngreso: 38, 
              ModuloId: 7,
              FuncionId: 20
          }
        },
        {
          name: 'VerificacionReciboDePagos', 
          path: 'VerificacionReciboDePagos', 
          component: VerificacionReciboDePagos,
          meta: { 
              tituloDeLaPagina: "Verificación de recibo de pagos", 
              RequiereAutenticacion: true, 
              ValidaSesion: true, 
              ObtenDatos: true, 
              ObtenPermisosDelSistema: true, 
              SistemaQueSeIngreso: 38, 
              ModuloId: 7,
              FuncionId: 21
          }
        },
        {
          name: 'DevolucionPagos', 
          path: 'DevolucionPagos', 
          component: DevolucionPagos,
          meta: { 
              tituloDeLaPagina: "Devolución de pagos", 
              RequiereAutenticacion: true, 
              ValidaSesion: true, 
              ObtenDatos: true, 
              ObtenPermisosDelSistema: true, 
              SistemaQueSeIngreso: 38, 
              ModuloId: 2,
              FuncionId: 22
          }
        },
        ,
        {
          name: 'ReporteDeRelacionDeCertificadosCobrados', 
          path: 'ReporteDeRelacionDeCertificadosCobrados', 
          component: ReporteDeRelacionDeCertificadosCobrados,
          meta: { 
              tituloDeLaPagina: "Reporte de relación de certificados de depósito cobrados", 
              RequiereAutenticacion: true, 
              ValidaSesion: true, 
              ObtenDatos: true, 
              ObtenPermisosDelSistema: true, 
              SistemaQueSeIngreso: 38, 
              ModuloId: 4,
              FuncionId: 23
          }
        },
        {
          name: 'ReporteDeRelacionDeChequesCobrados', 
          path: 'ReporteDeRelacionDeChequesCobrados', 
          component: ReporteDeRelacionDeChequesCobrados,
          meta: { 
              tituloDeLaPagina: "Reporte de relación de cheques cobrados", 
              RequiereAutenticacion: true, 
              ValidaSesion: true, 
              ObtenDatos: true, 
              ObtenPermisosDelSistema: true, 
              SistemaQueSeIngreso: 38, 
              ModuloId: 4,
              FuncionId: 24
          }
        },
        {
          name: 'ReporteDeRelacionDeCertificadosPagados', 
          path: 'ReporteDeRelacionDeCertificadosPagados', 
          component: ReporteDeRelacionDeCertificadosPagados,
          meta: { 
              tituloDeLaPagina: "Reporte de relación de certificados de depósito pagados", 
              RequiereAutenticacion: true, 
              ValidaSesion: true, 
              ObtenDatos: true, 
              ObtenPermisosDelSistema: true, 
              SistemaQueSeIngreso: 38, 
              ModuloId: 4,
              FuncionId: 25
          }
        },
        {
          name: 'ProcesadosReactivacion', 
          path: 'ProcesadosReactivacion', 
          component: ProcesadosReactivacion,
          meta: { 
              tituloDeLaPagina: "Reactivación del procesado", 
              RequiereAutenticacion: true, 
              ValidaSesion: true, 
              ObtenDatos: true, 
              ObtenPermisosDelSistema: true, 
              SistemaQueSeIngreso: 38, 
              ModuloId: 3,
              FuncionId: 26
          }
        }   

      ]
    }
]

export default SIVAC;


// WEBPACK FOOTER //
// ./src/router/SIVAC.js